module.exports = __webpack_public_path__ + "static/media/50.b3a6f432.JPG";